import { render } from "./CreateReview.vue?vue&type=template&id=fa3297f8&scoped=true"
import script from "./CreateReview.vue?vue&type=script&lang=js"
export * from "./CreateReview.vue?vue&type=script&lang=js"

import "./CreateReview.vue?vue&type=style&index=0&id=fa3297f8&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa3297f8"]])

export default __exports__